import {Action, getModule, Module, Mutation, VuexModule} from "vuex-module-decorators";
import store from "@/store";
import ModuleApi from "@/store/api";
import {CabinetSlotsSettingsRs, SlotsSettingsDto, UpdateCabinetSlotsSettingsRq} from "@/types/slots";
import { format } from 'date-fns';
import {mapToUpdateCabinetSlotsSettingsRq} from "@/mappers/slots";

//Mapping from CabinetSlotsSettingsRs to SlotsSettingsDto
function toDto(from: CabinetSlotsSettingsRs): SlotsSettingsDto {
    const dateExceptions = from.exceptions.map(date => new Date(date));
    return {
        userId: from.userId,
        timeZone: from.timeZone,
        monday: from.monday,
        tuesday: from.tuesday,
        wednesday: from.wednesday,
        thursday: from.thursday,
        friday: from.friday,
        saturday: from.saturday,
        sunday: from.sunday,
        exceptions: dateExceptions,
        createdAt: from.createdAt,
        updatedAt: from.updatedAt
    };
}

@Module({
    name: 'slots',
    namespaced: true,
    dynamic: true,
    store
})
class ModuleSlots extends VuexModule {

    //Get all available specialist slots
    @Action
    async getSlotsSettings() {
        const response = await ModuleApi.GET('/api/cabinet/slots/settings') as CabinetSlotsSettingsRs;
        return toDto(response)
    }

    //Update available specialist slots
    @Action
    async updateSlotsSettings(model: SlotsSettingsDto) {
        const request = mapToUpdateCabinetSlotsSettingsRq(model);
        const response =  await ModuleApi.POST({url: '/api/cabinet/slots/update-settings', body: request}) as CabinetSlotsSettingsRs;
        return toDto(response);
    }
}

export default getModule(ModuleSlots);
